/**
 * Runtime configuration loaded from /config.json at startup.
 *
 * This decouples environment-specific values from the build,
 * enabling a single frontend bundle for all environments (12-factor).
 */

interface AppConfig {
  apiBaseUrl: string
  /** Origin of the Fiscozen backoffice app, used to link out to customer profiles. */
  backofficeBaseUrl: string
}

let _config: AppConfig = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '/api/v1',
  backofficeBaseUrl: import.meta.env.VITE_BACKOFFICE_BASE_URL || 'https://app.fiscozen.internal',
}

/**
 * Fetch /config.json and store the result.
 * Must be called once before app mount.
 * Falls back to defaults if the fetch fails.
 */
export async function loadConfig(): Promise<void> {
  try {
    const res = await fetch('/config.json')
    if (res.ok) {
      const json = await res.json()
      _config = { ..._config, ...json }
    }
  } catch {
    // Fall back to defaults — local dev without config.json
  }
}

/** Return the current runtime config. Only valid after loadConfig() resolves. */
export function getConfig(): AppConfig {
  return _config
}
